export enum ScheduledNotificationStatus {
  Draft = 'Draft',
  Scheduled = 'Scheduled',
  Sent = 'Sent',
  Cancelled = 'Cancelled',
}
